type RiskResultControlType = 'Controlled' | 'Uncontrolled';

export const resolveRiskResultFileParentType = <TParentType>({
  existingParentType,
  controlType,
  controlledParentType,
  uncontrolledParentType,
}: {
  existingParentType?: TParentType;
  controlType: RiskResultControlType;
  controlledParentType: TParentType;
  uncontrolledParentType: TParentType;
}): TParentType =>
  existingParentType ??
  (controlType === 'Controlled'
    ? controlledParentType
    : uncontrolledParentType);
